



















































































































import { Component, Prop, Vue } from "vue-property-decorator";

interface ShiftDef {
  key: string;
  label: string;
  match: (jam: number) => boolean;
}

const SHIFT_DEFS: ShiftDef[] = [
  {
    key: "pagi",
    label: "Pagi (06:00–13:00)",
    match: (jam: number) => jam >= 6 && jam <= 12
  },
  {
    key: "sore",
    label: "Sore (13:00–19:00)",
    match: (jam: number) => jam >= 13 && jam <= 18
  },
  {
    key: "malam",
    label: "Malam (19:00–06:00)",
    match: (jam: number) => jam >= 19 || jam <= 5
  }
];

@Component
export default class Monitoring24JamIcuBalanceShiftView extends Vue {
  @Prop({ default: () => [] }) readonly entries!: any[];
  @Prop({ default: null }) readonly shiftTotals!: any;

  get sortedEntries(): any[] {
    // slice(): jangan mutasi array prop/store (reaktivitas Vue 2)
    return (this.entries || [])
      .slice()
      .sort(
        (a: any, b: any) => this.dayMinutes(a) - this.dayMinutes(b) || a.id - b.id
      );
  }

  get shiftView() {
    const totalsByKey: any = {};
    if (this.shiftTotals && Array.isArray(this.shiftTotals.shifts)) {
      for (const s of this.shiftTotals.shifts) {
        totalsByKey[s.key] = s;
      }
    }
    return SHIFT_DEFS.map(def => {
      const dalamShift = this.sortedEntries.filter((e: any) =>
        def.match(Number(e.jam))
      );
      return {
        key: def.key,
        label: def.label,
        masuk: this.groupJalur(dalamShift.filter((e: any) => e.arah === "masuk")),
        keluar: this.groupJalur(
          dalamShift.filter((e: any) => e.arah === "keluar")
        ),
        totals: totalsByKey[def.key] || null
      };
    });
  }

  get rekap24() {
    return this.shiftTotals ? this.shiftTotals.rekap24 || null : null;
  }

  groupJalur(entries: any[]): Array<{ jalur: string; entries: any[]; total: number }> {
    const out: Array<{ jalur: string; entries: any[]; total: number }> = [];
    for (const e of entries) {
      let row = out.find(r => r.jalur === e.jalur);
      if (!row) {
        row = { jalur: e.jalur, entries: [], total: 0 };
        out.push(row);
      }
      row.entries.push(e);
      row.total += Number(e.jumlah) || 0;
    }
    return out;
  }

  dayMinutes(e: any): number {
    // Hari form mulai 06:00 — jam 00-05 di ujung hari
    return ((Number(e.jam) - 6 + 24) % 24) * 60 + (Number(e.menit) || 0);
  }

  entryLabel(e: any): string {
    const jam = `${this.pad2(e.jam)}:${this.pad2(e.menit || 0)}`;
    const jumlah = this.formatCc(Number(e.jumlah) || 0);
    const jenis = String(e.jenis_cairan || "").trim();
    return jenis ? `${jenis} · ${jam} = ${jumlah}` : `${jam} = ${jumlah}`;
  }

  formatCc(n: number) {
    const v = Number(n) || 0;
    return Number.isInteger(v) ? v : Math.round(v * 10) / 10;
  }

  pad2(n: number) {
    return String(n || 0).padStart(2, "0");
  }
}
